import api from './api'

export const getIntegrationService = () => {
    const get = async () => {
        try {
            const resp = await api.execute('get', '/integrations')
            return resp
        } catch (e) {
            console.log(e)
        }
    }

    const update = async (integration) => {
        try {
            const resp = await api.execute('put', `/integrations/${integration.id}`, integration)
            return resp
        } catch (e) {
            console.log(e)
        }
    }

    const create = async (data) => {
        try {
            const resp = await api.execute('post', '/integrations', data)
            return resp
        } catch (e) {
            console.log(e)
        }
    }

    const remove = async (id) => {
        try {
            await api.execute('delete', `/integrations/${id}`)
            return get()
        } catch (e) {
            console.log(e)
        }
    }

    return { get, create, remove, update }
}
